import { render, staticRenderFns } from "./BaseTextarea.vue?vue&type=template&id=8474729c&"
import script from "./BaseTextarea.vue?vue&type=script&lang=js&"
export * from "./BaseTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8474729c')) {
      api.createRecord('8474729c', component.options)
    } else {
      api.reload('8474729c', component.options)
    }
    module.hot.accept("./BaseTextarea.vue?vue&type=template&id=8474729c&", function () {
      api.rerender('8474729c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/BaseTextarea.vue"
export default component.exports